

















































import { defineComponent, reactive } from "@vue/composition-api";

export default defineComponent({
    name: "ActionDialog",
    props: {
        message: { type: String, default: "" },
        title: { type: String, default: "Device actions" },
        options: { type: Object, default: null },
        value: { type: Boolean, default: false } // v-model
    },
    setup(props, context) {
        const option = reactive({
            color: "grey lighten-3",
            width: 420,
            zIndex: 200,
            unpairLabel: "Unpair",
            reenrollLabel: "Re-enroll"
        });

        if (props.options) {
            const opt: any = props.options;
            if (opt.color) option.color = opt.color;
            if (opt.width) option.width = opt.width;
            if (opt.zIndex) option.zIndex = opt.zIndex;
            if (opt.unpairLabel) option.unpairLabel = opt.unpairLabel;
            if (opt.reenrollLabel) option.reenrollLabel = opt.reenrollLabel;
        }

        const close = () => context.emit("input", false);

        const unpair = () => {
            close();
            context.emit("OnUnpair");
        };

        const reenroll = () => {
            close();
            context.emit("OnReenroll");
        };

        const cancel = () => {
            close();
            context.emit("OnCancel");
        };

        return { option, unpair, reenroll, cancel };
    }
});
